<template>
  <div>
    <div>
      <h1 class="text-center">Memberships</h1>
      <div>
        <List />
      </div>
    </div>
  </div>
</template>

<script>
import List from "./ListMemberships.vue";
export default {
  components: {
    List,
  },
};
</script>
